import type { TourChapter } from "../types";

export const FLIGHTS_CHAPTER: TourChapter = {
  id: "flights",
  title: "Flights",
  steps: [
    {
      id: "welcome",
      target: null,
      title: "Welcome to Hawk Atlas",
      body:
        "This is where your flights get reviewed. The video and the map are locked together, and " +
        "the points of interest, pins and frames you save are shared with your whole team.\n" +
        "The tour takes a few minutes and follows you from page to page. Skip it whenever you " +
        "like; the ? Tour button up top brings it back for whatever page you're on.",
    },
    {
      id: "list",
      target: "flights.list",
      title: "Your flights",
      body:
        "Every flight published to your team, oldest first. Looking after more than one client? " +
        "They're grouped into sections you can fold away.",
    },
    {
      id: "card",
      target: "flights.card",
      title: "A flight card",
      body:
        "Thumbnail, name and the day it was flown, plus a few chips. Editors is who's been " +
        "annotating it, a set chip means it's one recording of several, Shared by means another " +
        "team owns it, and ☁︎ ✓ means it's downloaded on this device.",
    },
    {
      id: "map",
      target: "flights.map",
      fallback: "skip",
      title: "Where each flight is",
      body:
        "Every flight in the list is drawn here with the same number as its card. Hover a card " +
        "to light its track up, and click a track to open that flight. Scroll the map to zoom " +
        "in; it stays put while you scroll the list.",
    },
    {
      id: "identity",
      target: "header.identity",
      title: "You",
      body:
        "The name you signed in with goes on every POI, pin, note and frame you make, and it's " +
        "what decides what you can edit. Sign out here if you're on a shared machine.",
    },
    {
      id: "install",
      target: "header.install",
      title: "Install as an app",
      body:
        "Install Hawk Atlas as an app and you get a full-screen window and sturdier offline " +
        "storage. Only some browsers offer it; on Safari it's Share → Add to Home Screen.",
    },
    {
      id: "offline",
      target: "header.offline",
      title: "Offline library",
      body:
        "Anything you've downloaded lives here: check it's all healthy, refresh it, or free up " +
        "some space. We'll swing back here at the end.",
    },
    {
      id: "handoff",
      target: null,
      title: "Open a flight",
      body: "That's the list. Everything else happens inside a flight.",
      handoff: "Open any flight and we'll pick it up there.",
    },
  ],
};
